// internal
import { axios, def, array, handleError, handleResponse } from './internal';
import { coolDownBegin, coolDownEnd } from '../request-control/cooldown';

// `hasReplies` comes from the caller's own list: a comment with replies is only emptied, one without is removed. The server
// answers before the delete is applied and returns neither.
function CommentDelete(postId, commentId, hasReplies, setData, buildCommentTree, onSuccess) {
    const key = `comment-delete:${commentId}`;
    if (!coolDownBegin(key)) return; // the previous request is still running or just finished (double click)
    setData?.((prev) => ({ ...prev, loading: true }));
    axios
        .delete(`/api/posts/${encodeURIComponent(postId)}/comments/${encodeURIComponent(commentId)}`)
        .then((res) => {
            switch (res.data.code) {
                case def.ErrorCode.OK:
                    setData((prev) => {
                        const data = hasReplies
                            ? prev.data.map((c) => (c._id === commentId ? { ...c, content: null, deleted: true } : c))
                            : array.removeInArray(prev.data, (c) => c._id === commentId);
                        const treeData = buildCommentTree(data);
                        return { ...prev, data, treeData };
                    });
                    onSuccess?.();
                    break;
                default:
                    handleResponse(res);
                    break;
            }
        })
        .catch((err) => {
            handleError(err);
        })
        .finally(() => {
            coolDownEnd(key);
            setData?.((prev) => ({ ...prev, loading: false }));
        });
}

export { CommentDelete };
